"use client";

import { useTranslation } from "@/hooks/useLanguage";
import {
  CreditCard,
  Hotel,
  Globe,
  Users,
  Building2,
  Smartphone,
} from "lucide-react";

const sponsorIcons = [
  <Hotel key="hotel" size={34} />,
  <Globe key="globe" size={34} />,
  <CreditCard key="card" size={34} />,
  <Building2 key="building" size={34} />,
  <Users key="users" size={34} />,
  <Smartphone key="phone" size={34} />,
];

export const Sponsors = () => {
  const { t } = useTranslation();
  const sponsorsList = t("sponsors.sponsors_list");

  // Ensure sponsorsList is always an array to prevent runtime errors
  const safeSponsorsList = Array.isArray(sponsorsList) ? sponsorsList : [];

  return (
    <section id="sponsors" className="container pt-24 sm:py-32">
      <h2 className="text-center text-md lg:text-xl font-bold mb-8 text-primary">
        {t("sponsors.title")}
      </h2>

      <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
        {safeSponsorsList.map((name, index) => (
          <div
            key={name}
            className="flex items-center gap-1 text-muted-foreground/60"
          >
            <span>{sponsorIcons[index]}</span>
            <h3 className="text-xl font-bold">{name}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};
